import Typography from "../typography/typography";
import logo from "../../assets/images";
import "./info-card.scss";

export interface InfoCardProps {
  label: string;
  dataPosition?: number;
  dataName?: string;
  value?: string;
}

const InfoCard = (props: InfoCardProps) => {
  const { label, dataPosition, dataName, value } = props;
  return (
    <>
      <Typography
        type="s5"
        weight="medium"
        mb={0.5}
        color={"theme.secondary.800"}
        data-position={dataPosition}
        data-name={dataName}
        className="infoCard"
      >
        {label}
        <img src={logo.info} />
      </Typography>
      <Typography color={"theme.secondary.1000"}>{value ?? "Info"}</Typography>
    </>
  );
};

export { InfoCard };
export default InfoCard;
